import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import BreadCrumb from "../../components/Common/BreadCrumb";
import { SkeletonTheme } from "react-loading-skeleton";
import AdminDashboard from "../AdminDashboard";
import UserDashboard from "../UserDashboard";
import useAuthUser from "../../components/Hooks/useAuthUser";
import { useTranslation } from "react-i18next";

const DashboardAnalytics = () => {
  const { t } = useTranslation();
  const { isSuperAdmin, isAdmin } = useAuthUser();
  const { isUserSwitch } = useSelector((state) => ({
    isUserSwitch: state.Profile.userSwitch.isUserSwitch,
  }));

  document.title = t("common.pageTitle", { page: t("dashboard.pageTitle") });

  return (
    <>
      <SkeletonTheme baseColor="#F0F4F6" highlightColor="#e9ebec">
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title={t("dashboard.pageTitle")} hideCrumbs={true} />
            {(isSuperAdmin || isAdmin) && isUserSwitch === false ? (
              <AdminDashboard key={!isUserSwitch} />
            ) : (
              <UserDashboard key={isUserSwitch} />
            )}
          </Container>
        </div>
      </SkeletonTheme>
    </>
  );
};

export default DashboardAnalytics;
